import styled from '@emotion/styled';

import { primaryColor } from '@zego/theme';

import BoldText from '@zego/components/BoldText';

const SmallHeaderText = styled(BoldText)({
  color: primaryColor(11),
  fontSize: 18,
  lineHeight: '24px',
});

export default SmallHeaderText;
